<template>
  <w-sliding-popup ref="navPopup" :title="title" @close="onClosePopup">
    <div slot="content">
      <w-eum-line-chart tabName="nav" :visible="visible" :params="params" @load="loadData" @reset="reset" />
      <el-row type="flex" justify="space-between" class="title-bar">
        <div class="title-h4">네비게이션 목록 {{ searchDateLabel }}</div>
        <el-button size="small" type="plain" @click="showSearchTool = !showSearchTool"><i class="fas fa-search" /></el-button>
      </el-row>
      <el-table-wrapper ref="navTable" :data="navData" :columns="columns" :column-default="columnDefault" :pagination="true" :show-custom-header="true" :show-search-tool="showSearchTool" />
    </div>
  </w-sliding-popup>
</template>

<script>
import { clone, isEmpty as objectIsEmpty } from 'lodash';
import { columnDefault } from '@/constants/table';
import { isEmpty } from '@/utils/basic';
import { getDateToString } from '@/utils/date';
import { convertMillisecondsToSeconds } from '@/utils/number';
import ApmCountAPI from '@/api/performance/apm/count-info';
import WEumLineChart from '../chart/EumLineChart';

export default {
  name: 'WNavDetailPopup',
  components: { WEumLineChart },
  props: {
    uri: String,
  },
  data() {
    return {
      columnDefault,
      columns: [
        { prop: 'ctxStartTime', label: '발생시각', width: 180, sortable: true, searchable: true, searchType: 'date', formatter: this.formatDatetime },
        { prop: 'endUserResponseTime', label: '응답 시간', sortable: true, formatter: this.convertMillisecondsValue },
        { prop: 'allPageLoadTime', label: '페이지 조회 시간', sortable: true, formatter: this.convertMillisecondsValue },
        { prop: 'domReadyTime', label: 'DOM 준비 시간', sortable: true, formatter: this.convertMillisecondsValue },
        { prop: 'domBuildingTime', label: 'DOM 구성 시간', sortable: true, formatter: this.convertMillisecondsValue },
        { prop: 'resourceFetchTime', label: '자원 패치 시간', sortable: true, formatter: this.convertMillisecondsValue },
      ],
      navData: [],
      showSearchTool: false,
      params: null,
      visible: false,
      searchDateLabel: null,
    };
  },
  computed: {
    title() {
      const uri = this.uri;
      if (!isEmpty(uri)) {
        return `${uri} 상세정보`;
      }
      return '네비게이션 상세정보';
    },
  },
  methods: {
    /**
     * 네이게이션 상세정보 팝업을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    open(params) {
      this.visible = true;
      this.params = params;
      this.$refs.navPopup.visible = true;
    },
    /**
     * 네이게이션 상세 리스트를 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadData(chartParams) {
      if (isEmpty(this.params)) {
        this.navData = [];
        return;
      }
      this.searchDateLabel = objectIsEmpty(chartParams) ? null : `[${getDateToString(parseFloat(chartParams.startDatetime), 'YYYY-MM-DD HH:mm:ss')} ~ ${getDateToString(parseFloat(chartParams.endDatetime), 'YYYY-MM-DD HH:mm:ss')}]`;

      const params = Object.assign(clone(this.params), chartParams);
      ApmCountAPI.getEumNavRawList(params).then((response) => {
        if (response.data.success) {
          this.navData = response.data.data;
        } else {
          this.navData = [];
        }
      });
    },

    /**
     * 슬라이딩 팝업을 닫는다.
     * @return {[type]} [description]
     * @author jda
     */
    onClosePopup() {
      this.navData = [];
      this.params = null;
      this.showSearchTool = false;
      this.visible = false;
      this.$refs.navPopup.visible = false;
      this.$refs.navTable.clearFilter();
    },
    /**
     * 발생 일시를 string type으로 변환
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    formatDatetime(row, column, value) {
      return getDateToString(value, 'YYYY-MM-DD HH:mm:ss');
    },
    /**
     * milliseconds -> seconds 단위 변환
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertMillisecondsValue(row, column, value) {
      return convertMillisecondsToSeconds(value);
    },
    reset() {
      this.searchDateLabel = null;
      this.navData = [];
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/apm/components/popup/NavDetailPopup.vue